export default {
  GENERIC: 'generic',
  ECOMV2: 'ecom_v2',
};
